import './Projects.css';
import ImageSlider from './Slider';
import { SliderData } from './SlideData.jsx';

const Projects = () => {
  return <ImageSlider slides={SliderData} />;
};

export default Projects;

